import { AxiosResponse } from 'axios';
import ApiService from './api';

export type StudentAdminItem = {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  dataSource: string;
  schoolId: string | null;
  schoolName: string | null;
  schoolState: string | null;
  schoolType: string | null;
  teacherId: string | null;
  teacherEmail: string | null;
  teacherFirstName: string | null;
  teacherLastName: string | null;
};

export type TeacherOption = {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
};

export const getTeachersBySchool = async (
  schoolId: string
): Promise<AxiosResponse<TeacherOption[]>> =>
  await ApiService.get<TeacherOption[]>('users/teachers-by-school', { schoolId });

export const assignStudent = async (
  studentId: string,
  body: { schoolId?: string; teacherUserId?: string | null }
): Promise<AxiosResponse<{ success: boolean }>> =>
  await ApiService.patch<typeof body, { success: boolean }>(`users/students/${studentId}/assign`, body);

export const getStudentsAdminList = async (
  page: number,
  limit: number,
  params: {
    orderBy?: string;
    search?: string;
    schoolId?: string;
    dataSource?: string;
    mappingStatus?: string;
  }
): Promise<AxiosResponse<StudentAdminItem[]>> =>
  await ApiService.get<StudentAdminItem[]>('users/students/admin-list', {
    page,
    limit,
    ...params,
  });
